const themeV3 = {
  colors: {
    // Neutral/Gray Scale
    neutral: {
      5: '#0D1117',
      10: '#171C22',
      15: '#22262C',
      20: '#2C3137',
      30: '#43474E',
      40: '#5A5F66',
      50: '#73777F',
      60: '#8D9199',
      70: '#A7ABB4',
      80: '#C3C6CF',
      90: '#DFE2EB',
      95: '#EDF1F9',
      98: '#F8F9FF',
      100: '#FFFFFF',
    },
    brand: {
      snappyBlue: {
        5: '#001225',
        10: '#001C37',
        15: '#002748',
        20: '#003259',
        30: '#00497F',
        40: '#0061A6',
        50: '#007ACF',
        60: '#3094EF',
        70: '#67AFFF',
        80: '#A0C9FF',
        90: '#D2E4FF',
        95: '#EAF1FF',
        98: '#F8F9FF',
      },
      snappyYellow: {
        5: '#171000',
        10: '#231B00',
        15: '#2F2500',
        20: '#3C2F00',
        30: '#574500',
        40: '#735C00',
        50: '#907400',
        60: '#AF8D00',
        70: '#CEA700',
        80: '#EFC200',
        90: '#FFE084',
        95: '#FFF0CA',
        98: '#FFF8F0',
      },
      snappyOrange: {
        5: '#250700',
        10: '#370E00',
        15: '#481500',
        20: '#5A1C00',
        30: '#7F2B00',
        40: '#A63B00',
        50: '#CF4C00',
        60: '#F4621A',
        70: '#FF8C5C',
        80: '#FFB599',
        90: '#FFDBCE',
        95: '#FFEDE7',
        98: '#FFF8F6',
      },
    },
    accent: {
      pink: {
        5: '#270022',
        10: '#3A0032',
        15: '#4B0042',
        20: '#5E0053',
        30: '#840076',
        40: '#AD009A',
        50: '#D705C0',
        60: '#F839DD',
        70: '#FF7AE3',
        80: '#FFACE8',
        90: '#FFD7F0',
        95: '#FFECF5',
        98: '#FFF7F9',
      },
      green: {
        5: '#00150F',
        10: '#002018',
        15: '#002C22',
        20: '#00382C',
        30: '#005141',
        40: '#006B56',
        50: '#00876D',
        60: '#00A485',
        70: '#00C19E',
        80: '#00E0B7',
        90: '#3FFED2',
        95: '#B9FFE8',
        98: '#E6FFF4',
      },
    },
    contextual: {
      active: {
        5: '#001503',
        10: '#002105',
        15: '#002D09',
        20: '#00390E',
        30: '#005318',
        40: '#006E23',
        50: '#008A2E',
        60: '#31A546',
        70: '#50C15D',
        80: '#6DDE76',
        90: '#89FB8F',
        95: '#C7FFC3',
        98: '#EBFFE5',
      },
      pending: {
        5: '#250700',
        10: '#370E00',
        15: '#481500',
        20: '#5A1C00',
        30: '#7F2B00',
        40: '#A63B00',
        50: '#CF4C00',
        60: '#F4621A',
        70: '#FF8C5C',
        80: '#FFB599',
        90: '#FFDBCE',
        95: '#FFEDE7',
        98: '#FFF8F6',
      },
      problem: {
        5: '#2D0002',
        10: '#410003',
        15: '#540005',
        20: '#680009',
        30: '#930011',
        40: '#BA1820',
        50: '#DE3635',
        60: '#FF544F',
        70: '#FF8980',
        80: '#FFB3AD',
        90: '#FFDAD6',
        95: '#FFEDEB',
        98: '#FFF8F7',
      },
    },
    // Gradients
    gradients: {
      auroraBoreal: {
        0: '#007ACF',
        20: '#4074DC',
        40: '#6A69E2',
        60: '#925ADF',
        80: '#B641D4',
        100: '#D705C0',
      },
      aiTwilight: {
        0: '#2E93EE',
        6: '#2E93EE',
        13: '#2F92ED',
        19: '#3091ED',
        25: '#3190EC',
        31: '#338EEB',
        38: '#358CE9',
        44: '#3789E8',
        50: '#3A86E6',
        56: '#3D83E4',
        63: '#417FE1',
        69: '#457BDF',
        75: '#4976DC',
        81: '#4E71D9',
        88: '#536CD5',
        94: '#5866D2',
        100: '#5E60CE',
      },
      blueGradient: {
        0: '#0070D1',
        6: '#0070D1',
        13: '#0271D2',
        19: '#0473D3',
        25: '#0775D4',
        31: '#0B78D5',
        38: '#107BD7',
        44: '#1680DA',
        50: '#1D84DC',
        56: '#258AE0',
        63: '#2D90E3',
        69: '#3796E7',
        75: '#419EEB',
        81: '#4DA5EF',
        88: '#59AEF4',
        94: '#66B7F9',
        100: '#74C1FF',
      },
      lightBlueGradient: {
        0: '#B1D6FF',
        6: '#D8E9FC',
        100: '#74C1FF',
      },
    },
  },
  font: {
    family: {
      brand: "'Galano', 'Roboto',sans-serif,'Helvetica Neue',sans-serif",
    },
    weights: {
      regular: 400,
      medium: 500,
      bold: 700,
    },
    sizes: {
      mini: '12px',
      small: '14px',
      medium: '16px',
      '1xmedium': '18px',
      large: '20px',
      '1xlarge': '24px',
      '2xlarge': '28px',
      huge: '32px',
      '1xhuge': '36px',
      '2xhuge': '40px',
    },
    lineHeight: {
      compact: '100%', // 1.0 - for captions and overlines
      spacious: '120%', // 1.2 - for titles with huge fonts
      relaxed: '130%', // 1.3 - for titles with large fonts
      comfortable: '150%', // 1.5 - for multi-line text, reading comfort
    },
  },
  shadows: {
    light: '0px 1px 3px rgba(0, 0, 0, 0.16)',
    dark: '0px 3px 6px rgba(0, 0, 0, 0.20)',
  },
  border: {
    radius: {
      none: '0px',
      sm: '4px',
      md: '8px',
      lg: '12px',
      xl: '16px',
      round: '24px',
      pill: '50%',
      circular: '50%',
    },
    width: {
      none: '0px',
      thin: '1px',
      medium: '2px',
      thick: '4px',
    },
  },
  breakpoints: {
    xs: '360px',
    sm: '600px',
    md: '960px',
    lg: '1280px',
    xl: '1920px',
  },
  spacing: {
    quarck: '4px',
    nano: '8px',
    xxxs: '16px',
    xxs: '24px',
    xs: '32px',
    sm: '40px',
    md: '48px',
    lg: '56px',
    xl: '64px',
    xxl: '80px',
    xxxl: '120px',
    huge: '160px',
    giant: '200px',
    inset: {
      quarck: { vertical: '4px', horizontal: '4px' },
      nano: { vertical: '8px', horizontal: '8px' },
      xs: { vertical: '16px', horizontal: '16px' },
      sm: { vertical: '24px', horizontal: '24px' },
      md: { vertical: '32px', horizontal: '32px' },
      lg: { vertical: '40px', horizontal: '40px' },
    },
  },
  icon: {
    size: {
      sm: '16px',
      md: '24px',
      lg: '32px',
      xl: '48px',
    },
    style: {
      fill: 0,
      weight: 300,
      grade: 0,
    },
  },
  layers: {
    hidden: -1,
    base: 0,
    header: 20,
    overlay: 30,
    modal: 40,
    awaysOnTop: 50,
    important: 99999,
  },
};

export default themeV3;
